export default "__VITE_ASSET__BA3dui16__"